module.exports = __webpack_public_path__ + "static/media/serviceIcons1.481be7c4.svg";